/* Kostenrechner fuer Ratgeber-Seiten: benannte Scan-Dienstleister
   gegen Kaufen gegen Mieten, mit Balkenvergleich.

   Einbindung im Seiteninhalt als schlichtes div NUR mit Klasse:

   <div class="rg-rechner-mount">
     <p>Fallback-Text, falls der Rechner nicht laden kann.</p>
   </div>

   Achtung: Der Shopify-Seiteneditor entfernt beim Speichern sowohl
   unbekannte Tags als auch data-Attribute. Nur id und class ueberleben
   ihn zuverlaessig. Die gesamte Konfiguration (Produkt-Handle,
   Kaufpreis, Abrufdatum) lebt deshalb hier im Skript.

   Die Mietpreise kommen live aus dem Shop (/products/<handle>.js).

   WICHTIG (vergleichende Werbung, § 6 UWG): Die Anbieterpreise unten
   muessen den regulaeren Listenpreisen der Anbieter entsprechen und
   bei Preisaenderungen aktualisiert werden. Quellen und Abrufdatum
   stehen je Anbieter im Kommentar, Beleg-Screenshots aufbewahren. */
(function() {

  /* Konfiguration. STAND ist das sichtbare Abrufdatum der
     Anbieterpreise - bei jeder Preisaktualisierung unten mitziehen. */
  var PRODUCT_HANDLE = 'fotoscanner-mieten-ab-7-tage-epson-fastfoto-ff-680w_354389496682_';
  var BUY_PRICE = 500;
  var STAND = '19.08.2026';

  /* Reguläre Listenpreise, abgerufen 19.08.2026:
     - MEDIAFIX (mediafix.de/fotos-digitalisieren), "Standard+ (600 dpi)",
       ohne Aktionsrabatt: bis 500: 0,29 / 501-1500: 0,25 /
       1501-2500: 0,22 / ab 2501: 0,19. Versand: "ggf. zzgl.".
     - MEDIADIG (mediadig.de/leistungen/fotos-digitalisieren), "Premium
       600 dpi": bis 200: 0,39 / 201-500: 0,33 / 501-1500: 0,31 /
       1501-2500: 0,29 / ab 2501: 0,28. Rueckseiten +0,19, TIFF +0,06.
     - CEWE (cewe.de/service/preisliste-scan-service.html), Foto-Scan:
       Klassik: Grundpreis 14,99 bis 10 Scans, danach 0,49 je Scan;
       ab 100: 0,39 / ab 500: 0,35 / ab 1000: 0,29 / ab 2000: 0,25.
       Pro: Grundpreis 19,99, danach 0,59; ab 100: 0,49 / ab 500: 0,45 /
       ab 1000: 0,39 / ab 2000: 0,35. Versand 9,99 je Auftrag.
       Rueckseiten-Scan kostet bei CEWE extra. */
  var PROVIDERS = [
    {
      group: 'MEDIAFIX',
      detail: 'Standard+ (600 dpi)',
      shipNote: 'ggf. zzgl. Versand',
      tiers: [
        { min: 2501, price: 0.19 },
        { min: 1501, price: 0.22 },
        { min: 501, price: 0.25 },
        { min: 0, price: 0.29 }
      ]
    },
    {
      group: 'MEDIADIG',
      detail: 'Premium (600 dpi)',
      tiers: [
        { min: 2501, price: 0.28 },
        { min: 1501, price: 0.29 },
        { min: 501, price: 0.31 },
        { min: 201, price: 0.33 },
        { min: 0, price: 0.39 }
      ]
    },
    {
      group: 'CEWE',
      detail: 'Foto-Scan Klassik',
      shipCost: 9.99,
      baseFee: 14.99,
      baseCovers: 10,
      basePerPhoto: 0.49,
      baseUpTo: 99,
      tiers: [
        { min: 2000, price: 0.25 },
        { min: 1000, price: 0.29 },
        { min: 500, price: 0.35 },
        { min: 100, price: 0.39 }
      ]
    },
    {
      group: 'CEWE',
      detail: 'Foto-Scan Pro',
      shipCost: 9.99,
      baseFee: 19.99,
      baseCovers: 10,
      basePerPhoto: 0.59,
      baseUpTo: 99,
      tiers: [
        { min: 2000, price: 0.35 },
        { min: 1000, price: 0.39 },
        { min: 500, price: 0.45 },
        { min: 100, price: 0.49 }
      ]
    }
  ];

  /* Ab wann die Mietdauer knapp werden koennte. Herleitung aus der
     Faustregel im Ratgeber: 1.000 Fotos brauchen ein bis zwei Tage
     inklusive Sortieren, eine Woche schafft also realistisch
     3.500 bis 7.000 Fotos - Schwelle konservativ bei 4.000. */
  var WEEK1_LIMIT = 4000;
  var WEEK2_LIMIT = 9000;

  var GROUP_NOTES = {
    'MEDIAFIX': ['Versand ggf. zusätzlich', 'Fotos gehen außer Haus'],
    'MEDIADIG': ['Rückseiten-Scan +0,19 €/Foto', 'Fotos gehen außer Haus'],
    'CEWE': ['Rückseiten-Scan kostet extra', 'Fotos gehen außer Haus']
  };

  function fmtEuro(value) {
    var hasCents = Math.round(value * 100) % 100 !== 0;
    return value.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    });
  }

  function providerCost(provider, count) {
    if (provider.baseFee && count <= provider.baseUpTo) {
      var extra = Math.max(0, count - provider.baseCovers);
      return { total: provider.baseFee + extra * provider.basePerPhoto, perPhoto: null };
    }
    for (var i = 0; i < provider.tiers.length; i++) {
      if (count >= provider.tiers[i].min) {
        return { total: count * provider.tiers[i].price, perPhoto: provider.tiers[i].price };
      }
    }
    return null;
  }

  function build(mount, product) {
    var weekPrices = {};
    (product.variants || []).forEach(function(variant) {
      var text = (variant.title || '') + ' ' + (variant.option1 || '');
      var match = text.match(/(\d+)\s*Woche/i);
      if (match) {
        var weeks = parseInt(match[1], 10);
        if (!(weeks in weekPrices) || variant.price < weekPrices[weeks]) {
          weekPrices[weeks] = variant.price;
        }
      }
    });

    var week1 = weekPrices[1] || null;
    var week2 = weekPrices[2] || null;
    if (!week1 && !week2) return;

    var buyPrice = BUY_PRICE;
    var stand = STAND;

    mount.innerHTML =
      '<div class="rg-rechner">' +
      '  <label for="RgRechnerInput"><strong>Wie viele Fotos hast du ungefähr?</strong></label>' +
      '  <div class="rg-rechner__row">' +
      '    <input type="range" id="RgRechnerSlider" min="100" max="10000" step="100" value="1000" aria-label="Anzahl Fotos">' +
      '    <input type="number" id="RgRechnerInput" min="50" max="50000" step="50" value="1000" inputmode="numeric">' +
      '  </div>' +
      '  <div class="rg-rechner__presets">' +
      '    <button type="button" data-preset="500">500</button>' +
      '    <button type="button" data-preset="1000">1.000</button>' +
      '    <button type="button" data-preset="3000">3.000</button>' +
      '    <button type="button" data-preset="10000">10.000</button>' +
      '  </div>' +
      '  <div class="rg-rechner__bars" data-out="bars"></div>' +
      '  <p class="rg-rechner__savings" data-out="savings"></p>' +
      '  <div class="rg-buystrip" data-out="buystrip"></div>' +
      '  <div class="rg-cards rg-rechner__cards" data-out="cards"></div>' +
      '  <p class="rg-rechner__note" data-out="note"></p>' +
      '</div>';

    var input = mount.querySelector('#RgRechnerInput');
    var slider = mount.querySelector('#RgRechnerSlider');
    var barsOut = mount.querySelector('[data-out="bars"]');
    var savingsOut = mount.querySelector('[data-out="savings"]');
    var buystripOut = mount.querySelector('[data-out="buystrip"]');
    var cardsOut = mount.querySelector('[data-out="cards"]');
    var noteOut = mount.querySelector('[data-out="note"]');

    noteOut.textContent = 'Anbieterpreise: reguläre Listenpreise laut Anbieter-Websites' +
      (stand ? ', abgerufen am ' + stand : '') +
      ', ohne Aktionsrabatte, Änderungen möglich. Kaufen: typischer Neupreis. Die Mietpreise kommen live aus unserem Shop.';

    function update() {
      var count = parseInt(input.value, 10);
      if (isNaN(count)) count = 1000;
      count = Math.min(50000, Math.max(50, count));
      slider.value = Math.min(10000, Math.max(100, count));

      var rent1Total = week1 ? week1 / 100 : null;
      var rent2Total = week2 ? week2 / 100 : null;
      var bars = [];
      var cheapestService = null;

      /* Anbieter berechnen und Karten je Anbietergruppe aufbauen */
      var groups = {};
      var groupOrder = [];
      PROVIDERS.forEach(function(provider) {
        var cost = providerCost(provider, count);
        if (!cost) return;
        var totalWithShip = cost.total + (provider.shipCost || 0);
        if (cheapestService === null || totalWithShip < cheapestService) {
          cheapestService = totalWithShip;
        }
        bars.push({
          label: provider.group + ' ' + provider.detail,
          total: totalWithShip
        });
        if (!groups[provider.group]) {
          groups[provider.group] = [];
          groupOrder.push(provider.group);
        }
        var perLine;
        if (cost.perPhoto) {
          perLine = cost.perPhoto.toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €/Foto';
        } else {
          perLine = 'Grundpreis + ' + provider.basePerPhoto.toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €/Foto';
        }
        if (provider.shipCost) {
          perLine += ' + ' + fmtEuro(provider.shipCost) + ' Versand';
        }
        groups[provider.group].push({
          detail: provider.detail,
          total: totalWithShip,
          perLine: perLine
        });
      });

      bars.push({ label: 'Selbst kaufen', total: buyPrice });
      if (rent1Total) {
        bars.push({
          label: 'Mieten · 1 Woche',
          total: rent1Total,
          rent: true,
          hint: count > WEEK1_LIMIT ? 'bei dieser Menge evtl. knapp' : ''
        });
      }
      if (rent2Total) {
        bars.push({
          label: 'Mieten · 2 Wochen',
          total: rent2Total,
          rent: true,
          emp: true,
          hint: count > WEEK2_LIMIT ? 'ggf. Verlängerung einplanen' : ''
        });
      }

      /* Guenstigste Option oben, hervorgehoben */
      bars.sort(function(a, b) { return a.total - b.total; });
      var maxTotal = bars[bars.length - 1].total;
      var barsHtml = '';
      bars.forEach(function(bar, index) {
        var pct = Math.max(4, Math.round(bar.total / maxTotal * 100));
        var classes = 'rg-bar' + (bar.rent ? ' rg-bar--rent' : '') + (index === 0 ? ' rg-bar--best' : '');
        var badges = '';
        if (index === 0) badges += '<span class="rg-bar__badge">Günstigste</span>';
        if (bar.emp) badges += '<span class="rg-bar__badge rg-bar__badge--emp">Empfehlung</span>';
        if (bar.hint) badges += '<span class="rg-bar__hint">' + bar.hint + '</span>';
        barsHtml += '<div class="' + classes + '">' +
          '<span class="rg-bar__label">' + bar.label + badges + '</span>' +
          '<div class="rg-bar__track"><div class="rg-bar__fill" style="width:' + pct + '%"></div></div>' +
          '<span class="rg-bar__value">ca. ' + fmtEuro(Math.round(bar.total)) + '</span>' +
          '</div>';
      });
      barsOut.innerHTML = barsHtml;

      /* Ersparnis gegen die Mietdauer rechnen, die zur Menge passt:
         bis zur Wochen-Schwelle reicht eine Woche, darueber zwei. */
      var rentRef = null;
      var rentRefText = '';
      if (rent1Total && count <= WEEK1_LIMIT) {
        rentRef = rent1Total;
        rentRefText = 'Schon mit einer Mietwoche sparst du';
      } else if (rent2Total) {
        rentRef = rent2Total;
        rentRefText = 'Mit zwei Mietwochen sparst du';
      } else if (rent1Total) {
        rentRef = rent1Total;
        rentRefText = 'Schon mit einer Mietwoche sparst du';
      }
      var saving = cheapestService === null || rentRef === null ? 0 : Math.round(cheapestService - rentRef);
      savingsOut.textContent = saving > 0
        ? rentRefText + ' gegenüber dem günstigsten Scan-Dienst ca. ' + fmtEuro(saving) + ', und deine Fotos bleiben bei dir.'
        : '';

      buystripOut.innerHTML = '<strong>Zum Vergleich, selbst kaufen: ca. ' + fmtEuro(buyPrice) + '.</strong> ' +
        'Das Gerät gehört dir, steht nach dem Projekt aber im Schrank.';

      var cardsHtml = '';
      groupOrder.forEach(function(groupName) {
        cardsHtml += '<div class="rg-card"><p class="rg-card-title">' + groupName + '</p>';
        groups[groupName].forEach(function(entry) {
          cardsHtml += '<p class="rg-card-sub">' + entry.detail + '</p>' +
            '<p class="rg-rechner__price">ca. ' + fmtEuro(Math.round(entry.total)) + '</p>' +
            '<p class="rg-rechner__per">' + entry.perLine + '</p>';
        });
        var notes = GROUP_NOTES[groupName] || [];
        if (notes.length) {
          cardsHtml += '<ul>';
          notes.forEach(function(note) { cardsHtml += '<li>' + note + '</li>'; });
          cardsHtml += '</ul>';
        }
        cardsHtml += '</div>';
      });

      cardsHtml += '<div class="rg-card rg-card--highlight"><p class="rg-card-title">Bei uns mieten</p>';
      if (rent2Total) {
        cardsHtml += '<p class="rg-card-sub">2 Wochen · Empfehlung</p>' +
          '<p class="rg-rechner__price">' + fmtEuro(rent2Total) + '</p>';
      }
      if (rent1Total) {
        cardsHtml += '<p class="rg-card-sub">1 Woche</p>' +
          '<p class="rg-rechner__price">' + fmtEuro(rent1Total) + '</p>';
      }
      cardsHtml += '<ul>' +
        '<li>Keine versteckten Kosten, Versand hin &amp; zurück inklusive</li>' +
        '<li>Niemand außer dir sieht deine Bilder</li>' +
        '<li>Bis 600 dpi, Rückseiten automatisch mit, so viele Fotos du schaffst</li>' +
        '</ul></div>';

      cardsOut.innerHTML = cardsHtml;
    }

    input.addEventListener('input', update);
    slider.addEventListener('input', function() {
      input.value = slider.value;
      update();
    });
    mount.querySelectorAll('[data-preset]').forEach(function(button) {
      button.addEventListener('click', function() {
        input.value = button.dataset.preset;
        update();
      });
    });

    update();
  }

  function init() {
    document.querySelectorAll('.rg-rechner-mount, [data-rechner-handle]').forEach(function(mount) {
      if (mount.dataset.initialized) return;
      mount.dataset.initialized = 'true';

      fetch('/products/' + (mount.dataset.rechnerHandle || PRODUCT_HANDLE) + '.js')
        .then(function(response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function(product) {
          build(mount, product);
        })
        .catch(function() {
          /* Fallback-Inhalt aus dem Seiten-HTML einfach stehen lassen */
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
